import { render, staticRenderFns } from "./DelMenuCatalog.vue?vue&type=template&id=4434bd28&scoped=true"
import script from "./DelMenuCatalog.vue?vue&type=script&lang=js"
export * from "./DelMenuCatalog.vue?vue&type=script&lang=js"
import style0 from "./DelMenuCatalog.vue?vue&type=style&index=0&id=4434bd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434bd28",
  null
  
)

export default component.exports